
export const PASSWORD_REGEX = {
  lowerCase: /(?=.*[a-z])\w+/,
  upperCase: /(?=.*[A-Z])\w+/,
  specialCharacter: /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/,
  numeric: /\d/,
};

export const transactionsTypeArray: ObjectKeyValuePair[] = [
  { label: "Deposits", value: "deposits" },
  { label: "Transfers", value: "transfers" },
];

export const genderOptions: ObjectKeyValuePair[] = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Others", value: "others" },
];

export const ADMIN_DESIGNATIONS: string[] = [
  "Account Manager",
  "Chief Compliance Officer",
  "Compliance Analyst",
  "Compliance Officer",
  "Customer Support",
  "Customer Support Lead",
  "Engineering Lead",
  "Finance Manager",
  "Fraud Analyst",
  "Head of Operations",
  "Operations Analyst",
  "Operations Manager",
  "Product Manager",
  "Risk Analyst",
  "Software Engineer",
  "Treasury Analyst",
];
export const DESIGNATION_LIST_ID = "admin-designation-suggestions";

export const PARTNER_CATEGORIES: ObjectKeyValuePair[] = [
  "Restaurant",
  "Shopping Mall",
  "Café",
  "Spa",
  "Gym",
  "Salon & beauty",
  "Other",
].map((category) => ({ label: category, value: category }));

export const NIGERIAN_STATES: ObjectKeyValuePair[] = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
].map((state) => ({ label: state === "FCT" ? "FCT (Abuja)" : state, value: state }));

export const SESSION_LIFETIME_OPTIONS: ObjectKeyValuePair[] = [7, 14, 30, 60, 90].map(
  (days) => ({ label: days === 30 ? "30 days (default)" : `${days} days`, value: days })
);

export const DEFAULT_SESSION_LIFETIME_DAYS = 30;

export const PARTNER_LOGO_MAX_BYTES = 2 * 1024 * 1024;

export const PARTNER_NAME_MAX_LENGTH = 50;
export const PARTNER_DESCRIPTION_MAX_LENGTH = 300;
export const PARTNER_BRANCH_NAME_MAX_LENGTH = 30;

export const VOUCHER_BATCH_NAME_MAX_LENGTH = 30;

export const PAYMENT_PROOF_MAX_BYTES = 10 * 1024 * 1024;
